import {gql} from '@apollo/client';
import {
    CustomerComplaintHqListFilter,
    CustomerComplaintListFilter,
} from '../types/CustomerComplaintType';

export const GET_CUSTOMER_COMPLAINT_COUNT = gql`
    query GetCustomerComplaintCountByFilters($filter: CustomerComplaintListFilterInput) {
        getCustomerComplaintCountByFilters(filter: $filter)
    }
`;

export interface GetCustomerComplaintCountResponse {
    getCustomerComplaintCountByFilters: number;
}

export interface GetCustomerComplaintCountVariables {
    filter?: CustomerComplaintListFilter;
}

// WMS 视角专用：资源码 + 仓库越权双重鉴权；filter.warehouseId 必填
export const GET_CUSTOMER_COMPLAINT_COUNT_FOR_WMS = gql`
    query GetCustomerComplaintCountForWms($filter: CustomerComplaintListFilterInput!) {
        getCustomerComplaintCountForWms(filter: $filter)
    }
`;

export interface GetCustomerComplaintCountForWmsResponse {
    getCustomerComplaintCountForWms: number;
}

// QC 总部（HQ）视角专用：纯资源码鉴权（CS_DSP_APPEAL_SUMMARY），filter 不含 warehouseId（全美），时间范围必填
export const GET_CUSTOMER_COMPLAINT_COUNT_FOR_HQ = gql`
    query GetCustomerComplaintCountForHq($filter: CustomerComplaintHqListFilterInput!) {
        getCustomerComplaintCountForHq(filter: $filter)
    }
`;

export interface GetCustomerComplaintCountForHqResponse {
    getCustomerComplaintCountForHq: number;
}

export interface GetCustomerComplaintCountForHqVariables {
    filter: CustomerComplaintHqListFilter;
}
